import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const createFormTemplatesFormEditor = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "FormTemplatesFormEditor" */
    './FormTemplatesFormEditor.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
